<template>
  <pl-dialog
    :title="'Connect to LMS integration'"
    :size="'md'"
    :disableOutsideClick="true"
    @close="closeModal"
  >
    <body
      class="px-7 pb-10 flex flex-col flex-grow justify-center items-center overflow-y-auto"
    >
      <img src="/static/waffle_icons/unlock.svg" class="w-14" />
      <div class="my-8 text-2xl font-bold">
        You’ve discovered a premium feature!
      </div>
      <div class="mb-8 flex flex-col text-base font-normal">
        <div class="flex justify-center">
          You must have a schoolwide license to roster your class,
        </div>
        <div class="flex justify-center">
          create assignments and share assessment data with this integration.
        </div>
      </div>
      <div class="flex flex-col">
        <button
          class="mb-2.5 px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold"
          @click="upgrade"
        >
          Upgrade Now
        </button>
        <button
          class="px-8 py-2 bg-white hover:bg-gray-100 rounded cursor-pointer text-gray-500 font-semibold"
          @click="closeModal"
        >
          Maybe Later
        </button>
      </div>
    </body>
  </pl-dialog>
</template>
<script>
  export default {
    methods: {
      upgrade() {
        this.$emit('close');
        this.$router.push({
          name: 'profile.membership',
        });
      },
      closeModal() {
        if (
          this.$route.query.inviteModalOpen &&
          this.$route.query.roundtableID
        ) {
          this.$router.push({
            name: 'roundtable.index',
            params: {
              courseID: this.$route.params.courseID,
              roundtableID: this.$route.query.roundtableID,
            },
            query: {
              inviteModalOpen: true,
            },
          });
        } else if (
          this.$route.query.inviteModalOpen &&
          this.$route.query.liveDiscussionID
        ) {
          this.$router.push({
            name: 'live-discussion.index',
            params: {
              courseID: this.$route.params.courseID,
              liveDiscussionID: this.$route.query.liveDiscussionID,
            },
            query: {
              inviteModalOpen: true,
            },
          });
        }
        this.$emit('close');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// integrationsPremiumFeatureModal.vue?916e0b26